import { getTodayValue } from "./workspaceConfig";

const baseConfig = {
  noun: "record",
  createLabel: "Create record",
  placeholder: "Record name",
  types: ["Record", "Request", "Update"],
  statuses: ["Planned", "Active", "Review", "Blocked", "Done"],
  metrics: [
    { label: "Total", statuses: null, note: "Live records" },
    { label: "Active", statuses: ["Active", "In Progress"], note: "Moving now" },
    { label: "Review", statuses: ["Review", "In Review", "Client Review", "Pending"], note: "Needs decision" },
    { label: "Done", statuses: ["Done", "Completed", "Won", "Paid", "Approved"], note: "Closed records" },
  ],
};

export const moduleFunctionalConfig = {
  Home: {
    noun: "personal item",
    createLabel: "Create personal item",
    placeholder: "Task, ticket, meeting, document, leave, or notification",
    types: ["Task", "Ticket", "Project", "Meeting", "Attendance", "Leave", "Document", "Notification"],
    statuses: ["To Do", "In Progress", "In Review", "Blocked", "Done"],
  },
  "My Work": {
    noun: "work item",
    createLabel: "Create work item",
    placeholder: "Task, ticket, meeting, leave, doc, or wallet item",
    types: ["Task", "Ticket", "Project", "Meeting", "Attendance", "Leave", "Document", "Wallet"],
    statuses: ["To Do", "In Progress", "In Review", "Blocked", "Done"],
  },
  Schedule: {
    noun: "event",
    createLabel: "Create event",
    placeholder: "Meeting, booking link, availability block, or request",
    types: ["1:1 Meeting", "Group Meeting", "Client Review", "Daily Standup", "Training Session", "Interview", "Booking Link", "Booked Slot", "Paid Consultation", "Working Hours", "Availability Block", "Unavailable Slot", "Holiday Exception", "Buffer Rule", "Meeting Room", "Training Room", "Interview Room", "Virtual Room", "Equipment Resource", "Schedule Request"],
    statuses: ["Scheduled", "Requested", "Pending", "Confirmed", "Rescheduled", "Approved", "Rejected", "Active", "Blocked", "In Maintenance", "Disabled", "Cancelled", "Completed"],
  },
  Projects: {
    noun: "project",
    createLabel: "Create project",
    placeholder: "Delivery project for an onboarded client and their end client",
    types: ["Client Project", "End Client Delivery", "Internal Project", "Training Project", "Support Project", "Milestone"],
    statuses: ["Not Started", "Planning", "Active", "Client Review", "On Hold", "Completed", "Archived"],
    metrics: [
      { label: "Projects", statuses: null, note: "Total project records" },
      { label: "Active", statuses: ["Active", "Planning"], note: "Currently moving" },
      { label: "Client Review", statuses: ["Client Review", "Review"], note: "Waiting on client" },
      { label: "Closed", statuses: ["Completed", "Archived", "Done"], note: "Delivered" },
    ],
  },
  "Tasks & Tickets": {
    noun: "ticket",
    createLabel: "Create task/ticket",
    placeholder: "Bug, client request, internal task, or support ticket",
    types: ["Development Task", "Design Task", "Client Request", "Bug", "Support Ticket", "HR Task", "Sales Follow-up"],
    statuses: ["Idea", "New", "Backlog", "Needs Information", "Triaged", "To Do", "Planned", "Ready", "Approved", "In Progress", "In Review", "QA", "Blocked", "Waiting on Client", "Resolved", "Done", "Cancelled", "Duplicate", "Won't Fix"],
  },
  Work: {
    noun: "ticket",
    createLabel: "Create ticket",
    placeholder: "Task, bug, client request, support issue, or improvement",
    types: ["Ticket", "Task", "Bug", "Feature Request", "Support Request", "Improvement", "Incident", "Sprint", "Epic", "Backlog Item", "Approval", "Automation", "Template"],
    statuses: ["New", "Backlog", "Needs Information", "Triaged", "To Do", "Planned", "Ready", "Approved", "In Progress", "In Review", "QA", "Blocked", "Waiting on Client", "Resolved", "Done", "Cancelled", "Duplicate", "Won't Fix"],
    metrics: [
      { label: "Tickets", statuses: null, note: "Tasks, bugs, requests, and incidents" },
      { label: "In progress", statuses: ["In Progress"], note: "Currently moving" },
      { label: "Review", statuses: ["In Review"], note: "Waiting for QA, client, or manager" },
      { label: "Blocked", statuses: ["Blocked"], note: "Needs intervention" },
      { label: "Done", statuses: ["Done"], note: "Closed work" },
    ],
  },
  People: {
    noun: "people record",
    createLabel: "Create people record",
    placeholder: "Employee, team, role, attendance, leave, document, or performance note",
    types: ["Employee", "Team", "Role", "Attendance", "Leave Request", "Document", "Performance Note"],
    statuses: ["Active", "Invited", "Present", "Late", "On Leave", "Pending", "Approved", "Rejected", "Disabled"],
  },
  "Clients / CRM": {
    noun: "client record",
    createLabel: "Create client/lead",
    placeholder: "Lead, account client, contact, proposal, follow-up, or onboarding form",
    types: ["Lead", "Account Client", "Client", "Contact", "Proposal", "Follow-up", "Onboarding Form"],
    statuses: ["New Lead", "Contacted", "Demo Scheduled", "Proposal Sent", "Negotiation", "Won", "Lost", "Active"],
    metrics: [
      { label: "Pipeline", statuses: null, note: "CRM records" },
      { label: "Open Leads", statuses: ["New Lead", "Contacted", "Demo Scheduled", "Proposal Sent", "Negotiation"], note: "Sales motion" },
      { label: "Clients", statuses: ["Won", "Active"], note: "Converted accounts" },
      { label: "Lost", statuses: ["Lost"], note: "Closed lost" },
    ],
  },
  CRM: {
    noun: "client record",
    createLabel: "Create CRM record",
    placeholder: "Lead, client, deal, contact, follow up, contract, or form",
    types: ["Lead", "Client", "Deal", "Contact", "Meeting", "Form", "Follow Up", "Contract"],
    statuses: ["New Lead", "Contacted", "Demo Scheduled", "Proposal Sent", "Negotiation", "Won", "Lost", "Active"],
    metrics: [
      { label: "Pipeline", statuses: null, note: "CRM records" },
      { label: "Open Leads", statuses: ["New Lead", "Contacted", "Demo Scheduled", "Proposal Sent", "Negotiation"], note: "Sales motion" },
      { label: "Clients", statuses: ["Won", "Active"], note: "Converted accounts" },
      { label: "Lost", statuses: ["Lost"], note: "Closed lost" },
    ],
  },
  Training: {
    noun: "training record",
    createLabel: "Create training record",
    placeholder: "Trainer request, engagement, session, material, feedback, or outcome",
    types: ["Training Request", "Lyriclious Trainer Request", "Training Engagement", "Training Session", "Training Asset", "Training Feedback", "Training Outcome"],
    statuses: ["New", "Qualified", "Proposal Sent", "Approved", "Rejected", "Active", "Completed", "Cancelled"],
  },
  Docs: {
    noun: "document",
    createLabel: "Create document",
    placeholder: "SOP, policy, project doc, client doc, training doc, or template",
    types: ["SOP", "Policy", "Project Doc", "Client Doc", "Training Doc", "Template", "Meeting Notes"],
    statuses: ["Draft", "In Review", "Published", "Archived"],
  },
  Knowledge: {
    noun: "knowledge item",
    createLabel: "Create knowledge item",
    placeholder: "Document, SOP, template, policy, wiki page, or version note",
    types: ["Document", "SOP", "Template", "Policy", "Client Doc", "Project Doc", "Training Doc", "Wiki"],
    statuses: ["Draft", "In Review", "Published", "Archived"],
  },
  Finance: {
    noun: "finance record",
    createLabel: "Create finance record",
    placeholder: "Invoice, payment, payout, commission, refund, or wallet entry",
    types: ["Invoice", "Payment", "Wallet Entry", "Payout", "Commission", "Refund"],
    statuses: ["Pending", "Partially Paid", "Paid", "Overdue", "Refunded", "Approved", "Rejected"],
  },
  Marketing: {
    noun: "marketing item",
    createLabel: "Create marketing item",
    placeholder: "Blog, landing page, SEO item, campaign, coupon, or form",
    types: ["Campaign", "Email Campaign", "WhatsApp Campaign", "SMS Campaign", "Audience", "Message Template", "Consent Rule", "Marketing Automation", "Deliverability Review", "Blog", "Landing Page", "SEO", "Coupon", "Form"],
    statuses: ["Draft", "Planned", "Active", "Review", "Published", "Archived"],
  },
  Reports: {
    noun: "report",
    createLabel: "Create report",
    placeholder: "Work, project, HR, CRM, training, finance, or custom report",
    types: ["Work Report", "Project Report", "HR Report", "CRM Report", "Training Report", "Finance Report", "Custom Report"],
    statuses: ["Draft", "Ready", "Scheduled", "Exported", "Archived"],
  },
  Analytics: {
    noun: "analytics item",
    createLabel: "Create analytics dashboard",
    placeholder: "Productivity, project, people, CRM, finance, marketing, or custom dashboard",
    types: ["Productivity", "Projects", "People", "CRM", "Training", "Finance", "Marketing", "Custom Dashboard", "Export"],
    statuses: ["Draft", "Ready", "Scheduled", "Exported", "Archived"],
  },
  AI: {
    noun: "AI request",
    createLabel: "Create AI request",
    placeholder: "Summary, task generator, resume, SEO, or risk detection request",
    types: ["Assistant", "Summary", "Task Generator", "Resume", "SEO", "Risk Detection"],
    statuses: ["Queued", "Processing", "Ready", "Needs Review", "Archived"],
  },
  "AI Tools": {
    noun: "AI request",
    createLabel: "Create AI request",
    placeholder: "Assistant request, workflow, insight, or review",
    types: ["Assistant", "Workflow", "Summary", "Risk Detection", "Task Generator", "Insight"],
    statuses: ["Queued", "Processing", "Ready", "Needs Review", "Archived"],
  },
  "Support Desk": {
    noun: "support ticket",
    createLabel: "Create support ticket",
    placeholder: "Customer issue, request, incident, or conversation",
    types: ["Support Ticket", "Incident", "Service Request", "Customer Conversation", "Escalation"],
    statuses: ["New", "Triaged", "In Progress", "Waiting on Customer", "Resolved", "Closed"],
  },
  Procurement: {
    noun: "procurement request",
    createLabel: "Create procurement request",
    placeholder: "Purchase request, vendor, purchase order, or approval",
    types: ["Purchase Request", "Purchase Order", "Vendor", "Quote", "Approval"],
    statuses: ["Draft", "Requested", "Approved", "Ordered", "Received", "Rejected", "Cancelled"],
  },
  "Assets & Inventory": {
    noun: "asset record",
    createLabel: "Add asset or inventory item",
    placeholder: "Equipment, stock item, assignment, or maintenance request",
    types: ["Asset", "Inventory Item", "Assignment", "Maintenance", "Stock Adjustment"],
    statuses: ["Available", "Assigned", "In Maintenance", "Low Stock", "Retired", "Archived"],
  },
  "Client Admin": {
    noun: "client portal record",
    createLabel: "Create client update",
    placeholder: "Request, deliverable, approval, document, or project update",
    types: ["Client Request", "Deliverable", "Approval", "Project Update", "Client Document", "Access Request"],
    statuses: ["Open", "In Progress", "Review", "Approved", "Completed"],
  },
  "Client Payments": {
    noun: "client payment record",
    createLabel: "Create billing record",
    placeholder: "Invoice, payment, statement, or billing contact",
    types: ["Invoice", "Payment", "Statement", "Billing Contact"],
    statuses: ["Draft", "Sent", "Due", "Paid", "Overdue", "Voided"],
  },
  "Client Marketing": {
    noun: "reseller record",
    createLabel: "Create reseller record",
    placeholder: "Client account, pricing plan, invoice, payment, branding, or report",
    types: ["Client Account", "Pricing Plan", "Usage", "Invoice", "Payment", "Branding", "Report"],
    statuses: ["Draft", "Active", "Review", "Paid", "Overdue", "Archived"],
  },
  Settings: {
    noun: "setting",
    createLabel: "Create setting request",
    placeholder: "Workspace, role, permission, billing, integration, or security request",
    types: ["Workspace", "User Role", "Permission", "Billing", "Integration", "Security"],
    statuses: ["Requested", "Active", "Review", "Approved", "Disabled"],
  },
  Administration: {
    noun: "administration record",
    createLabel: "Create admin request",
    placeholder: "Workspace, user, role, permission, integration, security, billing, or automation request",
    types: ["Workspace", "User", "Role", "Permission", "Integration", "Security", "Audit Log", "API", "Billing", "Branding", "Automation"],
    statuses: ["Requested", "Active", "Review", "Approved", "Disabled"],
  },
};

export const getFunctionalConfig = (moduleName) => ({
  ...baseConfig,
  ...(moduleFunctionalConfig[moduleName] || {}),
});

export const getInitialWorkspaceDraft = (moduleName, owner = "") => {
  const config = getFunctionalConfig(moduleName);
  return {
    title: "",
    owner,
    priority: "Medium",
    status: config.statuses[0],
    due: getTodayValue(),
    type: config.types[0],
    description: "",
    sprint: "",
    epic: "",
    storyPoints: 0,
    assignees: "",
    labels: "",
    severity: "",
    approvalRole: "",
    templateName: "",
    automationTrigger: "",
    projectRef: "",
    projectSlug: "",
    startDate: "",
    team: "",
    parentRecordId: "",
    linkedRecordIds: [],
    linkedWorkType: "blocks",
    linkedWorkUrl: "",
    restrictRoles: [],
    flagged: false,
    flagReason: "Impediment",
    attachmentFiles: [],
    accountClient: "",
    endClient: "",
    clientPortalEnabled: false,
    portalRoles: [],
    portalMembers: [],
    portalMembersInput: "",
    scheduleStartTime: "",
    scheduleEndTime: "",
    scheduleDuration: "30",
    scheduleTimezone: typeof Intl !== "undefined"
      ? Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata"
      : "Asia/Kolkata",
    scheduleLocation: "",
    scheduleMeetingLink: "",
    scheduleCapacity: "",
    scheduleBuffer: "15",
    scheduleVisibility: "Workspace",
    scheduleRequestType: "",
    scheduleApprovalRequired: false,
    scheduleRepeatRule: "Does not repeat",
  };
};

export const getNextStatus = (status, moduleName) => {
  const statuses = getFunctionalConfig(moduleName).statuses;
  const currentIndex = statuses.indexOf(status);
  if (currentIndex === -1) return statuses[0];
  return statuses[(currentIndex + 1) % statuses.length];
};

export const countByStatuses = (records, statuses) => {
  if (!statuses) return records.length;
  return records.filter((record) => statuses.includes(record.status)).length;
};
